<template>
  <div>
    <el-input v-model="dd"
              :disabled="disabled"
              type="textarea"
              :rows="4"
              size="small"></el-input>
  </div>
</template>
<script>
import LibProductItem from '../../../minxin/ProductItem';

export default {
  name: "ProductItemTypeText",
  mixins: [LibProductItem],
  props: {
    value: String,
  },
  computed: {
    options() { return this.list }
  },
}
</script>
